import { Component } from '@angular/core';
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-info-medico',
  standalone: true,
  imports: [
    NgOptimizedImage
  ],
  templateUrl: './info-medico.component.html',
  styleUrl: './info-medico.component.css'
})
export class InfoMedicoComponent {

}
